export default __webpack_public_path__ + "static/media/166.52f52594.svg";